import { render, staticRenderFns } from "./RequestRgApprove.vue?vue&type=template&id=6e2cc752&scoped=true"
import script from "./RequestRgApprove.vue?vue&type=script&lang=js"
export * from "./RequestRgApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2cc752",
  null
  
)

export default component.exports